export default httpClient => ({
    getAll: async ({ token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/colunas', { headers });
        return {
            data: response.data
        }
    },
    save: async (dados, token) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.post('/colunas', dados, { headers });
        console.log(dados)
        return {
            data: response.data
        }
    },
    getById: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/colunas/' + id, { headers });
        return {
            data: response.data
        }
    },
    update: async (dados, token) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.put('/colunas/' + dados.id, dados, { headers });
        return {
            data: response.data
        }
    },
    delete: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.delete('/colunas/' + id, { headers });
        return {
            data: response
        }
    },
    getColuna: async ({ nome_url }) => {
        const response = await httpClient.get('/colunas-por-colunista/' + nome_url);
        return {
            data: response.data
        }
    },
    getColunaNome: async ({ titulo_url }) => {
        const response = await httpClient.get('/coluna/' + titulo_url);
        return {
            data: response.data
        }
    },

});